interface IVerificationResult {
  valid: boolean;
  errors: string[];
}

export const verifyStrongPassword = (password: string): IVerificationResult => {
  if (!password) {
    return {
      valid: true,
      errors: []
    }
  }

  const errors: string[] = [];
  if (password.length < 6) {
    errors.push('Should be 6 characters or more');
  }

  if (!/[a-z]{1,}/.test(password)) {
    errors.push('Should contain at least 1 lowercase letter');
  }
  if (!/[A-Z]{1,}/.test(password)) {
    errors.push('Should contain at least 1 uppercase letter');
  }
  if (!/[0-9]{1,}/.test(password)) {
    errors.push('Should contain at least 1 number');
  }
  if (!/[^\w\s]{1,}/.test(password)) {
    errors.push('Should contain at least 1 special character');
  }

  return {
    valid: errors.length === 0,
    errors
  }
}

export const verifyValidEmail = (email: string): boolean => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email ?? '');

export const verifyValidUrl = (url: string): boolean => /^https:\/\/[a-zA-Z0-9\-._~:/?#[\]@!$&'()*+,;=%]+$/.test(url ?? '')